import { useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";

export default function QuizRegister() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile_number: "",
    password: "",
    college_name: "",
    date_of_birth: "",
    college_roll_number: "",
  });

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/auth/register", { ...form, role: "user" });
      alert("Registered successfully");
      // navigate("/");
      window.location.reload();
    } catch (err) {
      console.log(err);

      // Check if server sent a custom error message
      if (err.response && err.response.data && err.response.data.message) {
        console.log(err?.response?.data?.message);
        alert(err?.response?.data?.message);
      } else {
        alert("Registration failed. Please try again.");
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-card" style={{ maxWidth: "80%" }}>
        <h2 className="login-title text-center mb-4">User Registration</h2>
        <form onSubmit={handleSubmit}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            <div>
              <label>
                <strong>Student Name</strong>
              </label>
              <input
                className="form-input"
                name="name"
                placeholder="Enter your full name"
                onChange={handleChange}
                value={form.name}
                required
              />
            </div>

            <div>
              <label>
                <strong>Email</strong>
              </label>
              <input
                className="form-input"
                name="email"
                type="email"
                placeholder="Enter your email"
                onChange={handleChange}
                value={form.email}
                required
              />
            </div>

            <div style={{ position: "relative" }}>
              <label>
                <strong>Password</strong>
              </label>
              <input
                className="form-input"
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Create a password"
                onChange={handleChange}
                value={form.password}
                required
                style={{ paddingRight: "40px" }}
              />
              {form.password && (
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "35px",
                    right: "10px",
                    cursor: "pointer",
                    userSelect: "none",
                    fontSize: "14px",
                    color: "#007bff",
                  }}
                >
                  {showPassword ? (
                    <img
                      width="20"
                      height="20"
                      src="https://img.icons8.com/ios-glyphs/30/hide.png"
                      alt="hide"
                    />
                  ) : (
                    <img
                      width="20"
                      height="20"
                      src="https://img.icons8.com/ios-glyphs/30/visible--v1.png"
                      alt="visible--v1"
                    />
                  )}
                </span>
              )}
            </div>

            <div>
              <label>
                <strong>Phone Number</strong>
              </label>
              <input
                className="form-input"
                name="mobile_number"
                type="tel"
                placeholder="Enter your phone number"
                onChange={handleChange}
                value={form.mobile_number}
                required
              />
            </div>

            <div>
              <label>
                <strong>College Name</strong>
              </label>
              <input
                className="form-input"
                name="college_name"
                placeholder="Enter college name"
                onChange={handleChange}
                value={form.college_name}
                required
              />
            </div>

            <div>
              <label>
                <strong>Date of Birth</strong>
              </label>
              <input
                className="form-input"
                name="date_of_birth"
                type="date"
                onChange={handleChange}
                value={form.date_of_birth}
                required
              />
            </div>

            <div>
              <label>
                <strong>College Roll No</strong>
              </label>
              <input
                className="form-input"
                name="college_roll_number"
                placeholder="Enter your roll number"
                onChange={handleChange}
                value={form.college_roll_number}
                required
              />
            </div>
          </div>

          <div style={{ marginTop: "32px" }}>
            <button type="submit" className="btn btn-primary w-full">
              Register
            </button>
          </div>
        </form>
        <div className="text-center mt-3">
          <p className="text-16">
            You have an account{" "}
            <a
              className="text-primary"
              href="/quiz"
              style={{ textDecoration: "underline" }}
            >
              Sign in
            </a>{" "}
            here.
          </p>
        </div>
      </div>
    </div>
  );
}
